const isPotentialPartner = (state: AnyFixMe) =>
  state.helpHome.isPotentialPartner;

export { isPotentialPartner };
